export const POSSIBLE_LOCALES = ['fr-FR', 'en-US'] as const;
export type Locale = (typeof POSSIBLE_LOCALES)[number];
